// Change this
const module = 'configurations'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/settings/configurations/Index'

var prefix = '/settings/'

export default [
    {
        path: prefix+`${module}/`,
        name: `${module}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
]
